import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import { isEmpty } from "lodash";
export const allEmpty = all => {
  var _context;
  return _filterInstanceProperty(_context = _Object$values(all)).call(_context, item => item == "shown").length === 0;
};
export const someVisible = all => {
  var _context2;
  return _filterInstanceProperty(_context2 = _Object$values(all)).call(_context2, item => item == "shown").length > 0;
};
export const emptyObject = object => {
  return isEmpty(object) === true;
};
export const stringify = data => _JSON$stringify(data);
export const registerHandlebarHelpers = Handlebars => {
  Handlebars.registerHelper("allEmpty", allEmpty);
  Handlebars.registerHelper("someVisible", someVisible);
  Handlebars.registerHelper("emptyObject", emptyObject);
  Handlebars.registerHelper("stringify", stringify);
};